export type NotificationEntityType = 'appointment' | 'task' | 'birthday' | 'quote' | 'reminder' | 'order_due'

export default class Notification {
  static ENDPOINT_TODAY     = '/notifications/today'
  static ENDPOINT_BY_DATE   = '/notifications/by-date'
  static ENDPOINT_MARK_READ = '/notifications/mark-read'
  static ENDPOINT_MARK_ALL  = '/notifications/mark-all-read'
  static ENDPOINT_REMINDERS = '/notifications/reminders'

  entityID:   string                 = ''
  entityType: NotificationEntityType = 'appointment'
  title:      string                 = ''
  subTitle:   string                 = ''
  date:       string                 = ''
  isRead:     boolean                = false
  repeatType: string                 = ''
  isDone:     boolean                = false

  static from(data: Partial<Notification>): Notification {
    return Object.assign(new Notification(), data)
  }

  navPath(): string {
    switch (this.entityType) {
      case 'appointment': return `/appointments/appointment/view/${this.entityID}`
      case 'birthday':    return `/customers/birthdays`
      case 'quote':       return `/sales/quotes/quote/${this.entityID}`
      case 'order_due':   return `/sales/orders/order/${this.entityID}`
      case 'reminder':    return ''
      default:            return ''
    }
  }
}
